import React from 'react';
import classNames from 'classnames/bind';

import type { NewsLabelsProps } from './types';
import styles from './styles.pcss';
import { NewsLabelsItem } from './NewsLabelsItem';

const cx = classNames.bind(styles);

export const NewsLabelsList: React.FC<NewsLabelsProps> = ({ labels, size }) => (
  <div className={cx('container')}>
    {labels.map(({ title, isActive }, id) => (
      <NewsLabelsItem id={id} isActive={isActive} key={`se-${id}`} size={size} title={title} />
    ))}
  </div>
);
